import http from "./http";

export default (labelId) => ({
  async index(filters) {
    return http
      .index("labels", filters)
      .then((json) => ({ labels: json }))
      .catch(async (e) => ({ labels: null, error: await e }));
  },
  async groups() {
    return http
      .index("labels/groups")
      .then((json) => ({ groups: json }))
      .catch(async (e) => ({ groups: null, error: await e }));
  },
  async get() {
    return http
      .get("labels", labelId)
      .then((json) => ({ label: json }))
      .catch(async (e) => ({ label: null, error: await e }));
  },
  async create(data) {
    return http
      .post("labels", data)
      .then((json) => ({ label: json }))
      .catch(async (e) => ({ label: null, error: await e }));
  },
  async update(data) {
    return http
      .put("labels", labelId, data)
      .then((json) => ({ label: json }))
      .catch(async (e) => ({ label: null, error: await e }));
  },
  async delete() {
    return http
      .delete("labels", labelId)
      .then((json) => ({ label: json }))
      .catch(async (e) => ({ label: null, error: await e }));
  },
});
